import { Component, type ReactNode } from "react";
import { useT } from "../i18n";
import { EmptyState } from "./ui";

/**
 * Error boundary around lazily loaded parts (maps; ADR 0019). A chunk that fails to load (offline, or an
 * old tab whose chunk was replaced by a deploy) shows a reload prompt in place instead of taking the whole
 * console down.
 */
export class LazyBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: unknown): void {
    console.warn("lazy part failed to load", error instanceof Error ? error.message : error);
  }

  render(): ReactNode {
    return this.state.failed ? <LazyFailed /> : this.props.children;
  }
}

function LazyFailed() {
  const t = useT();
  return (
    <EmptyState
      icon="alert"
      title={t("lazy.loadError")}
      action={
        <button type="button" className="button button-secondary" onClick={() => window.location.reload()}>
          {t("lazy.reload")}
        </button>
      }
    />
  );
}
